module.exports = __webpack_public_path__ + "img/MGH-Gion-15.be3b5345.jpg";